const initialState = {
  VERSION: "",
  NAMESPACE: "",
  PROXY_PATH: "",
  PUBLIC_URL: "",
  ANALYTICS_KEY: "",
  MAIN_COLOR: "#FDBE14",
  SECONDARY_COLOR: "#001C7B",
  BUILD: {
    tech: "",
    type: "",
  },
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONFIG/SET_CONFIG":
      const {
        VERSION,
        NAMESPACE,
        PROXY_PATH,
        PUBLIC_URL,
        ANALYTICS_KEY,
        BUILD,
      } = action.payload;
      return {
        ...state,
        VERSION,
        NAMESPACE,
        PROXY_PATH,
        PUBLIC_URL,
        ANALYTICS_KEY,
        BUILD: {
          ...state.BUILD,
          ...BUILD,
        },
      };
    default:
      return state;
  }
};

export default configReducer;
